import { useEffect, useState } from "react";
import { useGetUsersQuery } from "../Admin/adminApiSlice";
import {
  useUpdateGroupMutation,
  useGetAllGroupsQuery,
  useGetSingleGroupMutation,
} from "./groupApislice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMyContext } from "../../MyContext";

export default function ManageGroups() {
  const navigate = useNavigate();
  const { setToast } = useMyContext();
  const [searchParams] = useSearchParams();
  const requiredGroupId = searchParams.get("groupid");
  const {
    data: usersData = [],
    isLoading: isUserLoading,
    isError: isUserError,
    error: userError,
  } = useGetUsersQuery();

  const [
    updateGroup,
    {
      data: updatedGroupData,
      isError: isUpdateGroupError,
      error: updatedGroupError,
      isLoading: isUpdateGroupLoading,
      isSuccess: isUpdateGroupSuccess,
    },
  ] = useUpdateGroupMutation();
  const [getSingleGroup, { data: group }] = useGetSingleGroupMutation();

  const [groupDetails, setGroupDetails] = useState({
    groupName: "",
    groupMembers: [],
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (requiredGroupId) {
      getSingleGroup({ groupId: requiredGroupId });
    }
  }, [requiredGroupId]);

  useEffect(() => {
    if (group) {
      // console.log(group);
      setGroupDetails({
        groupName: group?.groupName,
        groupMembers: group?.members,
      });
    }
  }, [group]);

  const toggleUserSelection = (user) => {
    const userObject = {
      username: user.username,
      userId: user.userId,
    };
    let updatedGroup = groupDetails.groupMembers;
    if (updatedGroup.some((u) => u.userId === userObject.userId)) {
      updatedGroup = updatedGroup.filter((u) => u.userId !== userObject.userId);
    } else {
      updatedGroup = [...updatedGroup, userObject];
    }
    setGroupDetails((prev) => ({ ...prev, groupMembers: updatedGroup }));
  };

  const handleUpdateGroup = async () => {
    const updatedGroup = {
      groupId: requiredGroupId,
      groupName: groupDetails.groupName,
      members: groupDetails.groupMembers,
    };
    console.log(updatedGroup);
    updateGroup(updatedGroup);
  };
  useEffect(() => {
    if (isUpdateGroupError && updatedGroupError) {
      const errorMessage =
        updatedGroupError?.data?.message ||
        updatedGroupError?.data?.error ||
        "an error occured while creating the group";
      console.error(errorMessage);
      setToast({ message: errorMessage, status: "error" });
    }
    if (isUpdateGroupSuccess && updatedGroupData) {
      console.log(updatedGroupData?.message);
      const successMessage =
        updatedGroupData?.message || "Group created successfully";
      setToast({ message: successMessage, status: "success" });
      navigate("/home/dash/group");
    }
  }, [isUpdateGroupSuccess, isUpdateGroupError]);

  const filteredUsers = usersData
    .filter((u) => u.username.toLowerCase().includes(searchTerm.toLowerCase()))
    .map((m) => ({ username: m.username, userId: m._id }));

  return (
    <div className="overflow-hidden flex flex-col w-full h-[92vh]">
      <section className="flex items-center justify-between px-2 border border-b-0 border-gray-300 h-[6%] font-medium w-full">
        {groupDetails.groupName}
        <div className="flex justify-end gap-4 text-sm">
          <button
            // onClick={() => navigate("/home/dash/group")}
            className="border border-gray-400 rounded px-2 py-1 tracking-wide"
          >
            Cancel
          </button>
          <button
            onClick={handleUpdateGroup}
            className="border border-gray-400 rounded px-2 py-1 bg-blue-950 text-white tracking-wide"
          >
            {isUpdateGroupLoading ? "Updating..." : "Update"}
          </button>
        </div>
      </section>
      <section className="flex flex-col items-start justify-start border border-b-0 border-gray-300 h-[94%] w-full gap-2 p-2">
        {/* search user */}
        <div className="flex flex-col w-full md:w-1/2 items-start justify-start gap-1">
          <label htmlFor="searchTerm" className="font-medium text-sm">
            Search User
          </label>
          <input
            type="text"
            name="searchTerm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border rounded w-full h-auto p-[0.2rem] focus:outline-0"
          />
        </div>

        <div className="w-full items-start justify-start gap-2 grid grid-cols-1 md:grid-cols-4 h-[28rem] md:h-[39rem] overflow-hidden overflow-y-auto">
          {isUserLoading ? "fetching user..." : null}
          {Array.isArray(filteredUsers) && filteredUsers.length
            ? filteredUsers.map((user) => (
                <label
                  key={user.userId}
                  className="flex items-center space-x-2 text-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={groupDetails.groupMembers.some(
                      (u) => u.userId === user.userId
                    )}
                    onChange={() => toggleUserSelection(user)}
                    className="mr-[6px] checkbox-input"
                  />
                  <span className="text-sms">{user.username}</span>
                </label>
              ))
            : null}
          {isUserError && userError ? (
            <p className="text-red-500 font-semibold">
              {userError?.data?.message || "error fetching users"}
            </p>
          ) : null}
        </div>
      </section>
    </div>
  );
}
